import { Button } from "@aircall/ds";

import { ButtonLinkProps } from "./ButtonLink.decl";

export function ButtonLink({
  children,
  onClick,
  href,
  target = "_self",
  "data-test": dataTest = "button-link",
  ...buttonProps
}: ButtonLinkProps) {
  return (
    <Button
      onClick={onClick}
      data-test={dataTest}
      render={<a href={href} target={target} />}
      nativeButton={false}
      className="h-auto whitespace-nowrap rounded-md border-0 bg-[#5bf1b2] px-4 py-3 text-base font-semibold text-[#004736] no-underline hover:bg-[#5bf1b2]"
      {...buttonProps}
    >
      {children}
    </Button>
  );
}
